import Dialog from '@/components/container/dialog';
import confirm from '@/components/container/confirm';
import imgUpload from '@/components/container/imgUpload';
import slider from '@/components/container/slider';
import {error,toast} from './plugin/toast';
import {loading} from './plugin/loading';
/**
 * 挂载全局插件
*/
window.$plugin = {
	error,toast,loading
}

/**
 * 导出插件
*/
export {
	Dialog,confirm,imgUpload,slider
}



// WEBPACK FOOTER //
// ./src/components/plugin.js